// extracted by mini-css-extract-plugin
export var calendarView = "_ng-0";